import styled from 'styled-components';

import {Spinner} from '../../components/Spinner/Spinner';

export const RightButtonWrapper = styled.div<{shouldAlwaysStack?: boolean}>`
  margin-top: 20px;

  ${({theme, shouldAlwaysStack}) =>
    !shouldAlwaysStack &&
    theme.media.sm`
      display: flex;
      flex-flow: row-reverse nowrap;
      align-items: center;
      gap: 0.5em;
    `}
`;

type Props = React.HTMLAttributes<HTMLDivElement> & {
  isSubmitting: boolean;
  children: React.ReactNode;
  shouldAlwaysStack?: boolean;
};
export function FormButtonWrapper({
  isSubmitting,
  children,
  ...props
}: Props): React.JSX.Element {
  return (
    <RightButtonWrapper {...props}>
      {isSubmitting ? <Spinner /> : children}
    </RightButtonWrapper>
  );
}
